{
  "remove": "Eltávolítás"
}
